<div class="row_1">
    <div>
        <label class="label tab-heading titlered">Tier Setup</label>
        <label class="label tab-heading" *ngIf="isAccessible" (click)="openRouteLevel('ew-configuration')">E/W
            Configuration</label>
        <label class="label tab-heading" *ngIf="isAccessible" (click)="openRouteLevel('history')">History</label>
        <label class="label tab-heading" *ngIf="isAccessible" (click)="openRouteLevel('periods')">Periods</label>
        <button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue();">Add To
            Queue</button>
    </div>
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
        <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="tiersRefreshData()">
        <app-periods-dropdown periodLabel="Period" module="Tiers" (eventHandler)="componentEventHandler($event);">
        </app-periods-dropdown>


        <button class="primarybutton" style="float: right;margin-right: 1%;"
            (click)="copyDialog('copy-tier');">COPY</button>
        <button class="primarybutton" style="float: right;" (click)="addDialog('add-tier');">ADD</button>
        <div class="grid-agg">
            <label class="gridcaption">Tiers</label>
            <ag-grid-angular style="width:100%;height: 390px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                (gridReady)="tiersOnGridReady($event);" (window:resize)="tiersSizeToFit()" [animateRows]="true"
                [defaultColDef]="defaultColDef" [columnDefs]="TIERS_columnDefs" [rowData]="TIERS_displayRowData"
                  [context]="TIERS_context" [pagination]="true" [paginationPageSize]="TIERS_rowCount"
                [icons]="TIERS_icons">
            </ag-grid-angular>
            <div class="row col-12" style="bottom: 24px; position: relative; padding-left :13px">

                <div class="w-25 col-4 ">
                    <div>
                        <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                        <select class="page-drpdwn" (change)="tiersOnPageSizeChanged($event)">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="ALL" selected>ALL</option>
                        </select>
                        <!-- <label style="padding-left:9px"> of {{rowCount}}</label> -->
                    </div>
                </div>

                <div style="display: flex;" class="pagination_text col-4 offset-2">

                    <!-- first -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="tiersGoToFirstPage()"
                        [ngClass]="{'disable_icon':tiersGetCurrentPage()== true,'enable_icon':tiersGetCurrentPage()!= true}">
                        first_page</mat-icon>

                    <!-- previous -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="tiersGoToPreviousPage()"
                        [ngClass]="{'disable_icon':tiersGetCurrentPage()== true,'enable_icon':tiersGetCurrentPage()!= true}">
                        keyboard_arrow_left</mat-icon>

                    <p class="total_row_text">Total Row {{TIERS_rowCount}}</p>

                    <!-- next -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':tiersIsLastPage()== true,'enable_icon':tiersIsLastPage()!= true}"
                        (click)="tiersGoToNexpage()">keyboard_arrow_right
                    </mat-icon>

                    <!-- last -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':tiersIsLastPage()== true,'enable_icon':tiersIsLastPage()!= true}"
                        (click)="tiersGoToLastPage()">last_page
                    </mat-icon>

                </div>

            </div>
        </div>
    </div>
    <div class="top_grid_agg" style="margin-top: 2%;">
        <app-notification-message [errorMessage]="SHUTTLES_ErrorMessage" [successMessage]="SHUTTLES_SuccessMessage">
        </app-notification-message>

        <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="shuttlesRefreshData()">
        <app-periods-dropdown periodLabel="Period" module="Shuttles" (eventHandler)="componentEventHandler($event);">
        </app-periods-dropdown>
        <button class="primarybutton" style="float: right;" (click)="copyDialog('copy-shuttle');">COPY</button>
        <button class="primarybutton" style="float: right;" (click)="addDialog('add-shuttle');">ADD</button>


        <div class="grid-agg">
            <label class="gridcaption">Shuttles</label>
            <ag-grid-angular style="width:100%;height: 390px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                [defaultColDef]="defaultColDef" (gridReady)="shuttlesOnGridReady($event);"
                (window:resize)="shuttlesSizeToFit()" [animateRows]="true" [columnDefs]="SHUTTLES_columnDefs"
                [rowData]="SHUTTLES_displayRowData"   [context]="SHUTTLES_context"
                [pagination]="true" [paginationPageSize]="SHUTTLES_rowCount" [icons]="SHUTTLES_icons">
            </ag-grid-angular>
            <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                <div class="w-25 col-4 ">
                    <div>
                        <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                        <select class="page-drpdwn" (change)="shuttlesOnPageSizeChanged($event)">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="ALL" selected>ALL</option>
                        </select>
                        <!-- <label style="padding-left:9px"> of {{rowCount}}</label> -->
                    </div>
                </div>

                <div style="display: flex;" class="pagination_text col-4 offset-2">

                    <!-- first -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="shuttlesGoToFirstPage()"
                        [ngClass]="{'disable_icon':shuttlesGetCurrentPage()== true,'enable_icon':shuttlesGetCurrentPage()!= true}">
                        first_page</mat-icon>

                    <!-- previous -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="shuttlesGoToPreviousPage()"
                        [ngClass]="{'disable_icon':shuttlesGetCurrentPage()== true,'enable_icon':shuttlesGetCurrentPage()!= true}">
                        keyboard_arrow_left</mat-icon>

                    <p class="total_row_text">Total Row {{SHUTTLES_rowCount}}</p>

                    <!-- next -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':shuttlesIsLastPage()== true,'enable_icon':shuttlesIsLastPage()!= true}"
                        (click)="shuttlesGoToNexpage()">keyboard_arrow_right
                    </mat-icon>

                    <!-- last -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':shuttlesIsLastPage()== true,'enable_icon':shuttlesIsLastPage()!= true}"
                        (click)="shuttlesGoToLastPage()">last_page
                    </mat-icon>

                </div>

            </div>
        </div>
    </div>
</div>